import { fetchApi } from '@/config/axiosSetting.ts';
import { VoiceOtpMutationDataType } from '@/modules/Auth/queries/voiceOtp/voiceOtpMutation.type.ts';

export const voiceOtpMutationFunction = (
  formData: VoiceOtpMutationDataType,
) => {
  return fetchApi({
    method: 'post',
    url: 'verification/login/create_voice_otp/',
    data: formData,
  });
};
